var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc24SocialTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M15.645 3c.308 2.648 1.786 4.226 4.355 4.394v2.978c-1.489.145-2.793-.341-4.31-1.26v5.57c0 7.075-7.713 9.286-10.814 4.215-1.993-3.263-.773-8.99 5.62-9.22v3.141a9.245 9.245 0 0 0-1.484.364c-1.422.481-2.228 1.382-2.004 2.972.431 3.045 6.017 3.946 5.553-2.004V3.006h3.084V3Z",
  clipRule: "evenodd"
})));
export default SvgIc24SocialTiktok;